import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {TableComp} from 'sz-react-utils'
import moment from 'moment'
import {
    Table,
    Badge,
    Card,
    Tooltip,
    Popconfirm,
    notification,
    Row, Col,
    Select,
    Drawer,
    Switch, AutoComplete, Spin,
    Input, Button, Icon, Tag
} from 'antd'
import Request from '../../../request'
import _ from 'lodash'
//import styles from './styles.less'
import {connect} from 'react-redux'
import {getUrlPushWrapper} from '../../../routes'
import {hideLoader, showLoader} from '../../../modules/actions'
import {FaFileInvoice} from 'react-icons/fa'


const {Option} = Select

class AllInvoices extends Component {

    deleteInvoice = async data => {
        this.setState({loading: true})
        let x = await Request.deleteInvoice(data)
        this.setState({loading: false})

        this.table.current.reload()
        if (!x.error) {
            notification.success({
                message: x.message,
                duration: 20,
                key: `${data._id}-close`
            })

        } else {
            notification.error({
                message: x.message || 'Try Again',
                duration: 20,
                key: `${data._id}-close`
            })
        }


    }
    apiRequest = (params) => {

        if (params.page) {
            this.state.currentPage = params.page
        }

        let currentUser = JSON.parse(window.localStorage.getItem("user"))

        if (currentUser && currentUser.userType == "RO") {
            this.state.ownerId = currentUser._id
        }
        return new Promise(async (resolve) => {

            if (this.state.ownerId) {
                params.quoteOwner = this.state.ownerId
            }
            if (this.state.contactNameId) {
                params.contactName = this.state.contactNameId
            }
            params.sortField = 'createdAt'
            params.sortOrder = 'desc'
            let data = await Request.getAllInvoices({
                ...params, regExFilters: ['dealName', 'carrier']
            })
            this.setState({count: data.total})
            resolve(data)
        })
    }
    downloadInvoiceSheet = async (item, key) => {
        this.setLoaderForFile(key, true)

        let resp = await Request.downloadInvoiceSheet(item)
        this.setLoaderForFile(key, false)
    }
    handleContactSearch = async (test) => {
        // this.setState({​​​​​​​​showSpin: true}​​​​​​​​)
        this.setState({selectedContact: test})
        if (test == '') {
            this.setState({
                allContacts: this.state.allContacts,
                selectedContact: test,
                contactNameId: null
            }, () => this.table.current.reload())
            //   , () => {
            //   this.setState({
            //     showSpin: false,
            //   })
            // })
            return false
        }
        let {data, error, message} = await Request.contactSearch({text: test})
        if (!error) {
            this.setState({allContacts: data}, () => {
                this.setState({showSpin: false})
            })
        }
    }

    onContactSelect = (val) => {
        let selectedContact = this.state.allContacts.find((obj) => obj._id === val)
        if (selectedContact) {
            this.setState({
                contactNameId: selectedContact._id,
                selectedContact: `${selectedContact.firstName} (${selectedContact.mobile})`
            }, () => {
                this.table.current && this.table.current.reload()
            })
        }
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.state = {
            visible: false,
            currentPage: 1,
            key: Date.now(),
            fileDownloadLoader: [],
            carrier: ['Fedex', 'DHL', 'UPS', 'USPS', 'BlueDart']
        }

    }

    setLoaderForFile = (key, value) => {
        let {fileDownloadLoader} = this.state
        let newLoading = _.clone(fileDownloadLoader)
        newLoading[key] = value
        this.setState({fileDownloadLoader: newLoading})
    }

    getOptionsData = async () => {
        // const { currentUser } = this.props
        let currentUser = JSON.parse(window.localStorage.getItem("user"))
        let filter = {};
        let params = {};
        if (currentUser && currentUser.userType === 'RO') {
            filter._id = currentUser._id
            this.setState({isRO: true, roOfficer: currentUser._id})
        }
        let roQuery = currentUser && currentUser.userType === 'RO' ? {contactOwner: currentUser && currentUser._id} : {}


        Request.getAllROList(filter).then(({data: userList}) => {
            this.setState({userList: userList || []})
        })
        if (currentUser && currentUser.userType === 'RO') {
            params.contactOwner = currentUser._id;
            let {data} = await Request.getAllContacts({
                ...params
            });
            this.setState({allContacts: data || []})
        } else {

            Request.getAllContacts().then(({data: allContacts}) => {
                this.setState({allContacts: allContacts || []})
            })
        }
    }

    async componentDidMount() {
        this.getOptionsData()
    }

    render() {
        const {submitting, dispatch, currentUser} = this.props
        const {userList, allContacts, isRO, roOfficer, currentPage} = this.state;
        let user = JSON.parse(window.localStorage.getItem("user"))


        const columns = [
            {
                title: 'S.No',
                dataIndex: 'sno',
                width: 50,
                key: 'sno',
                fixed: 'left',
                render: (value, item, index) => (currentPage - 1) * 10 + index + 1
            },
            {
                title: 'Invoice No',
                dataIndex: 'invoiceNo',
                // width: 100,
                key: 'invoiceNo',
                searchTextName: 'invoiceNo'

            },

            {
                title: 'Lead Name',
                key: 'dealName',
                searchTextName: 'dealName'

            },
            {
                title: 'Quote Owner',
                key: 'quoteOwner',
                // width: 150,
                render: (val, record) => {
                    return (<div>
                        <div>{record.quoteOwner ? record.quoteOwner.name : ''}</div>
                        <div>{record.quoteOwner ? record.quoteOwner.email : ''}</div>
                        <div>{record.quoteOwner ? record.quoteOwner.mobile : ''}</div>
                    </div>)
                }

            },
            {
                title: 'Contact Name',
                key: 'contactName',
                // width: 150,
                render: (val, record) => {
                    return (<div>
                        {record.contactName ? record.contactName.firstName : ''} {record.contactName && record.contactName.lastName ? record.contactName.lastName : ''}<br/>
                        {record.contactName && record.contactName.mobile ? record.contactName.mobile : ''}
                    </div>)
                }

            },
            {
                title: 'Carrier',
                dataIndex: 'carrier',
                key: 'carrier',
                searchTextName: 'carrier'
                // width: 150
            },

            {
                title: 'Validity (Days)',
                dataIndex: 'validDate',
                // width: 120,
                key: 'validDate'
            },

            {
                title: 'Created At',
                // width: 150,
                key: 'createdAt',
                dataIndex: 'createdAt',
                render: (text, record) => {
                    return (
                        <Tag>
                            {text ? moment(text).format('lll') : ''}
                        </Tag>
                    )
                },
                sorter: true
            },

            {
                key: 'actions',
                title: 'Actions',
                fixed: 'right',
                width: 120,
                render: (text, record, key) => {

                    return <React.Fragment>
                        <Tooltip title="Edit Invoice">
                            <Button
                                shape="circle"
                                style={{marginRight: 6}}
                                size="small"
                                onClick={() => {
                                    dispatch(
                                        getUrlPushWrapper('invoice.editInvoice', {
                                            id: record._id
                                        })
                                    )
                                }}
                                icon="edit"
                            />
                        </Tooltip>
                        <Tooltip title="Delete Invoice">
                            <Popconfirm
                                title="Are you sure delete this Invoice?"
                                onConfirm={() => {
                                    this.deleteInvoice({_id: record._id})
                                }}
                                onCancel={() => {
                                }}
                                okText="Yes"
                                cancelText="No">
                                <Button
                                    shape="circle"
                                    size="small"
                                    style={{marginRight: 6}}
                                    icon="delete"
                                />
                            </Popconfirm>

                        </Tooltip>

                        <Tooltip title="Download Invoice">
                            <Button
                                type="warning"
                                size="small"
                                shape="circle"
                                style={{marginTop: '6px'}}
                                loading={this.state.fileDownloadLoader[key]}

                                onClick={() => {
                                    this.downloadInvoiceSheet(record, key)
                                }}
                                icon="download"
                            />
                        </Tooltip>

                    </React.Fragment>

                }
            }


        ]
        if (user && user.userType == "RO") {
            columns.splice(2, 1);
        }


        return (
            <PageHeaderWrapper
                title={this.state.count ? `All Invoices: ${this.state.count}` : `All Invoice: 0`}>

                <Card bordered={true}>

                    <Row>
                        <Col span={8}>
                            <h4 style={{display: 'inline-block', marginRight: '10px'}}>Select Quote Owner</h4>
                            <Select
                                showSearch
                                allowClear
                                optionFilterProp="children"
                                style={{
                                    width: 225

                                }}
                                disabled={isRO}
                                value={isRO ? roOfficer : this.state.ownerId}
                                placeholder="Select Quote Owner"
                                onChange={id => {
                                    this.setState({ownerId: id}, () => {
                                        this.table.current.reload()
                                    })
                                }}
                            >
                                {userList &&
                                userList.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val._id}>
                                            {val.name} ({val.mobile})
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col span={8}>
                            <h4 style={{display: 'inline-block', marginRight: '10px'}}>Select Contact Name</h4>
                            <AutoComplete
                                value={this.state.selectedContact}
                                style={{
                                    width: 225,
                                }}
                                notFoundContent={this.state.showSpin && <Spin/>}
                                autoComplete={'none'}
                                onSelect={this.onContactSelect}
                                onSearch={this.handleContactSearch}
                                placeholder={'Search Contact'}
                            >{allContacts && allContacts.map((val, item) => (
                                <Option value={val._id}>
                                    <>
                                        <div><b>{`${val.firstName} (${val.mobile})`}</b></div>
                                    </>
                                </Option>
                            ))}

                            </AutoComplete>
                        </Col>
                    </Row>
                    <TableComp ref={this.table}
                               columns={columns}
                               apiRequest={this.apiRequest}
                               extraProps={{scroll: {x: 800}}}
                               pagination={{
                                   ...this.state.pagination,
                                   defaultPageSize: 10,
                                   pageSizeOptions: ['10', '25', '50', '100'],
                                   showSizeChanger: true,
                                   ...this.props.pagination
                               }}/>

                </Card>

            </PageHeaderWrapper>)

    }
}


const mapStateToProps = ({global}) => ({
    categories: global.categories,
    currentUser: global.currentUser
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllInvoices)
